export default __webpack_public_path__ + "static/media/sport-ninja.0bccd153.png";